import {
  Condition,
  FinanceType,
  ProtectionPlansSelectionType,
} from '@upstart/harmony/lib/constants';

const DefaultNewProduct = {
  raw: {},
  enabled: false,
  displayName: '',
  description: [],
  markup: 0,
  discount: 0,
  imageUrl: null,
  retailPrice: 0,
  productDealerCode: '',
  videoUrl: null,
  brochureUrl: null,
  availability: {
    [Condition.NEW]: {
      [FinanceType.CASH]: true,
      [FinanceType.LEASE]: true,
      [FinanceType.PURCHASE]: true,
    },
    [Condition.USED]: {
      [FinanceType.CASH]: true,
      [FinanceType.PURCHASE]: true,
    },
  },
  coverageNamesAndDeductibles: {
    [Condition.NEW]: {
      [FinanceType.CASH]: {},
      [FinanceType.LEASE]: {},
      [FinanceType.PURCHASE]: {},
    },
    [Condition.USED]: {
      [FinanceType.CASH]: {},
      [FinanceType.PURCHASE]: {},
    },
  },
  selectedInStore: ProtectionPlansSelectionType.None,
  selectedOnline: ProtectionPlansSelectionType.None,
};

export default DefaultNewProduct;
